<template> 
    <div class="botonWhatsApp" @click="enviarMensaje()"> 
     <i class="ri-whatsapp-line mr-2"></i>  Si estas interesado click aqui y contactanos via WhatsApp 
     </div>  
  <div class="container-fluid bg-dark text-white" id="contacto">
    <footer class="container py-5">
      <div class="row justify-content-between">
        <div class="col-4 col-md-2">
          <img :src="require(`@/assets/svg/logo-full.svg`)" class="img-fluid" />
          <small class="d-block mb-3 text-muted">&copy; 2017-2023</small>
          <div class="d-flex g-3 justify-content-around font-30">
              <a href="https://www.instagram.com/alliancesoft/" target="_blank" class="ri-instagram-line"></a>
              <a href="https://api.whatsapp.com/send/?phone=%2B584127873235&text=%C2%A1Hola%21+Me+gustar%C3%ADa+obtener+m%C3%A1s+informaci%C3%B3n+sobre+Alliance.&type=phone_number&app_absent=0" class="ri-whatsapp-line"></a>
              <a href="https://www.linkedin.com/company/alliance-technology-soft/" target="_blank" class="ri-linkedin-box-line"></a>
              <a href="https://www.youtube.com/@allianceST" target="_blank" class="ri-youtube-line"></a>
              <a href="https://www.tiktok.com/@alliancesoft?lang=es" target="_blank" class="ri-tiktok-line"></a>
          </div>
        </div>
        <div class="col-6 col-md small">
          <h5>Contáctanos</h5>
          <ul class="list-unstyled text-small">
            <li>
              <span  @click="enviarMensaje()" class="link">{{
                phone?.mask
              }}</span>
            </li>
            <li>
              <a :href="`mailto:${email}`">{{ email }}</a>
            </li>
            <li>
              <a  href="/VE/Interes#preguntas_frecuentes" >{{
                'Preguntas frecuentes'
              }}</a>
            </li>
            <li>
              <a  href="/VE/Interes#funciones_principales" >{{
                'Funciones principales'
              }}</a>
            </li>
          </ul>
        </div>
        <div class="col-6 col-md">
          <h5>Navegación</h5>
          <ul class="list-unstyled text-small text-ligth">
            <li
              v-for="item in mainMenu"  :key="item.label"
            >
              <a class="" :href="item.anchor">{{ item.label }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row justify-content-between mt-2">
        <div class="col-12">
          <span class="small text-muted">All rights reserved - Alliance Inteligencia contable</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mainMenu } from "@/utils/Menu";
// import { email, phone } from "@/utils/Helpers";

import { email, phone } from "../../../utils/helpers"

export default {
  name: "Footer",
  components: {},
  data() {
    return {
      mainMenu: [...mainMenu],
      phone: phone,
      email: email
    };
  },
  created() {},
  mounted() {},
  methods: { 
    enviarMensaje() {
        const phoneNumber = phone.number; // Reemplaza con el número de WhatsApp (sin signos ni espacios)
        const messageFijo = encodeURIComponent(`¡Hola! Me gustaría obtener más información sobre Alliance.`); // Tu mensaje personalizado 
        const url = `https://wa.me/${phoneNumber}?text=${messageFijo}`;
        window.open(url, "_blank");
      }
  } 
};
</script>

<style lang="scss" scoped>

  .link {
    color: #007bff;
    cursor: pointer;
  }

  .botonWhatsApp {
    background-color: #25D366;
    color: #fff;
    display: flex;
    align-items: center; 
  }

  .font-30 {
    font-size: 30px;
    a {
      cursor: pointer;
      text-decoration: none;
      color: #fff;
    }
  }

</style>
